/* eslint-disable */
<template>
  <v-container>
    <v-layout>
      <v-flex  class="text-xs-center pb-3">
        <h1>Tell Us a Little About Yourself</h1>
      </v-flex>
    </v-layout>

    <v-layout row v-if="userIsAuthenticated">

      <v-flex xs8 offset-xs2>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="addNewStudent">
                <v-layout row>
                  <v-flex xs4 offset-xs1>
                    <v-text-field
                      name="name"
                      label="Full Name"
                      id="name"
                      v-model="name"
                      ></v-text-field>
                  </v-flex>

                  <v-flex xs5 offset-xs1>
                    <v-text-field
                      name="school"
                      label="School You Are Currently Attending"
                      id="school"
                      v-model="school"
                      ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs4 offset-xs1>
                    <v-select
                      v-model="standing"
                      :items="standings"
                      label="Current Standing"
                      required
                    ></v-select>
                  </v-flex>

                  <v-flex xs5 offset-xs1>
                    <v-text-field
                      name="gpa"
                      label="Current GPA (4.0 Scale)"
                      id="gpa"
                      v-model="gpa"
                      ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs10 offset-xs1>
                    <v-textarea
                    name="experiences"
                    label="Relevant Work Experiences"
                    id="experiences"
                    multi-line
                    v-model="experiences"
                    hint="Include any previous work or research experience."
                    required></v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12 class="text-xs-center pt-4">
                    <v-btn
                      class="primary"
                      large
                      type="submit">Submit
                    </v-btn>
                  </v-flex>
                </v-layout>

              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      role: 'student',
      name: '',
      gpa: '',
      standing: '',
      experiences: '',
      school: '',
      standings: [
        'Freshman',
        'Sophomore',
        'Junior',
        'Senior'
      ]
    }
  },
  computed: {
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    }
  },
  methods: {
    addNewStudent () {
      const newStudent = {
        role: this.role,
        name: this.name,
        gpa: this.gpa,
        standing: this.standing,
        experiences: this.experiences,
        school: this.school
      }
      this.$store.dispatch('addNewStudent', newStudent)
      this.$router.push('/')
    }
  }
}
</script>
